import type { ListTableLazyHandlerProps } from "./list-table-lazy-handler.type";

import { getListLazyHeightInCss } from "@/modules/list/list.helper";

import { useListTableLazyHandler } from "./list-table-lazy-handler.hook";

const ListTableLazyHandler = (props: ListTableLazyHandlerProps) => {
  useListTableLazyHandler(props);

  const { lazyOptions } = props;
  const lazyMaxHeight = getListLazyHeightInCss(lazyOptions);

  return (
    <style>{`.list-table{--app-list-table-max-height:${lazyMaxHeight};}`}</style>
  );
};

export default ListTableLazyHandler;
